import React from 'react';
import ProjectManagementDashboard from '@/components/ProjectManagement';

/**
 * ProjectDashboard Page
 * Alias for the unified ProjectManagement shell — both /project-management and
 * /project-dashboard now share one component instance via AppRouter's combined route,
 * so switching between them never unmounts the sidebar or shell layout.
 */
export default function ProjectDashboardPage() {
    return <ProjectManagementDashboard initialNav="dashboard" />;
}
